import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import HeadingLayout from "src/components/base/heading-layout";
import { useTranslation } from "react-i18next";
import { ApiUser } from "src/api/api_user";
import { DescriptionDetails, DescriptionList, DescriptionTerm } from "src/components/base/description-list";
import { Badge } from "src/components/base/badge";

/**
 * The properties for {@link UserDashboard}
 */
export type UserDashboardProps = {};

/**
 * Dashboard for the user
 */
export default function UserDashboard(props: UserDashboardProps) {
    const [t] = useTranslation("user-dashboard");

    const now = new Date();
    const data = Route.useLoaderData();

    /**
     * Calculates the remaining days until the access expires
     *
     * @param data The expiration date of the access
     * @returns The remaining days until the access expires
     */
    const remainingDays = (data: string) => {
        const now = new Date();
        const expires = new Date(data);
        const diff = Math.abs(expires.getTime() - now.getTime());
        return Math.ceil(diff / (1000 * 3600 * 24));
    };

    return (
        <HeadingLayout heading={t("heading.welcome")}>
            <DescriptionList>
                <DescriptionTerm>
                    {!data.has_access && new Date(data.access_start) > now
                        ? t("label.access-starts")
                        : t("label.expiration")}
                </DescriptionTerm>
                <DescriptionDetails>
                    <Badge color={data.has_access ? "green" : data.is_access_planned ? "blue" : "zinc"}>
                        {data.has_access
                            ? data.access_expires_at
                                ? t("label.remaining-days", { remainingDays: remainingDays(data.access_expires_at) })
                                : t("label.unlimited")
                            : data.is_access_planned
                              ? data.access_expires_at
                                  ? t("label.access-planned-until", {
                                        start: new Date(data.access_start).toLocaleString(),
                                        remainingDays: remainingDays(data.access_expires_at),
                                    })
                                  : t("label.access-planned", { start: new Date(data.access_start).toLocaleString() })
                              : t("label.access-expired")}
                    </Badge>
                </DescriptionDetails>
            </DescriptionList>
        </HeadingLayout>
    );
}

export const Route = createFileRoute("/_user/u/dashboard/")({
    component: UserDashboard,
    loader: async () => await ApiUser.localUser.getAccessExpiration(),
});
